module.exports={close:"Fechar",error:"Erro",info:"Informação",success:"Sucesso",warning:"Aviso"};